/**
 * Catalog in the web app (admin only; the store pages belong to the orders module): products,
 * groups, configurable options, addons, bundles and currencies. Each page is its own chunk.
 */
const page = (load, name) => () => load().then((m) => ({ Component: m[name] }));
const products = () => import('./Products.jsx');

export default {
  name: 'catalog',
  adminRoutes: [
    { path: 'catalog/groups', lazy: page(() => import('./Groups.jsx'), 'Groups') },
    { path: 'catalog/products', lazy: page(products, 'Products') },
    { path: 'catalog/products/:uuid', lazy: page(() => import('./ProductEditor.jsx'), 'ProductEditor') },
    { path: 'catalog/options', lazy: page(() => import('./Options.jsx'), 'Options') },
    { path: 'catalog/addons', lazy: page(products, 'Addons') },
    { path: 'catalog/bundles', lazy: page(() => import('./Bundles.jsx'), 'Bundles') },
    { path: 'billing/currencies', lazy: page(() => import('./Currencies.jsx'), 'Currencies') },
  ],
  adminNav: [
    {
      section: 'catalog',
      to: '/admin/catalog/products',
      label: 'Products',
      permission: 'admin.products.read',
      order: 10,
    },
    {
      section: 'catalog',
      to: '/admin/catalog/groups',
      label: 'Groups',
      permission: 'admin.products.read',
      order: 20,
    },
    {
      section: 'catalog',
      to: '/admin/catalog/options',
      label: 'Options',
      permission: 'admin.products.read',
      order: 30,
    },
    { section: 'catalog', to: '/admin/catalog/addons', label: 'Addons', permission: 'admin.products.read', order: 40 },
    {
      section: 'catalog',
      to: '/admin/catalog/bundles',
      label: 'Bundles',
      permission: 'admin.products.read',
      order: 50,
    },
    {
      section: 'billing_settings',
      to: '/admin/billing/currencies',
      label: 'Currencies',
      permission: 'admin.currencies.manage',
      order: 20,
    },
  ],
};
